// Vendor imports
const ReactRedux = require('react-redux')
const { Router } = require('react-router')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const ErrorBoundary = require('client-v2/common/components/error/boundary')
const ErrorTester = require('client-v2/common/components/error/tester')
const { IconsManager } = require('client-v2/common/containers/icons/context')
const {
  EmbeddedPlayerManager
} = require('client-v2/common/contexts/embedded-player')
const {
  ModalDepthManager,
  ModalDepthBody
} = require('client-v2/common/contexts/modal-depth')
const {
  ThemeManager
} = require('client-v2/common/contexts/theme')

/**
 * This propagates Redux and Router state down to child components
 * The actual markup is represented in the `WrappedComponent`
 * @param {React.Component} WrappedComponent
 * @returns {React.Component}
 */
module.exports = function (WrappedComponent) {
  function RootComponent(props) {
    return (
      tag(ErrorBoundary,
        tag(ReactRedux.Provider, {
          store: props.store
        },
          tag(ThemeManager,
            tag(IconsManager,
              tag(ErrorTester),
              tag(Router, {
                history: props.history
              },
                tag(ModalDepthManager,
                  tag(ModalDepthBody),
                  tag(EmbeddedPlayerManager,
                    tag(WrappedComponent)
                  )
                )
              )
            )
          )
        )
      )
    )
  }

  if (__DEV__) {
    // Prop-checking imports
    const PropTypes = require('prop-types')

    RootComponent.propTypes = {
      history: PropTypes.object.isRequired,
      store: PropTypes.object.isRequired
    }
  }

  RootComponent.factory = tag.bind(null, RootComponent)

  return RootComponent
}
